module.exports = __webpack_public_path__ + "static/media/renewalGenerator.f6692036.svg";